/**
 * Log to console only in a development environment i.e. when NODE_ENV = `development`
 *
 * `console.log()` is useful for debugging in a development environment but not so much in production, therefore the environment variable `NODE_ENV` could be used to control logging
 *
 * @param {...any} args Arguments to be logged to console
 */
export default function debugLog(...args) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console -- intentional dev-only console
    console.log(...args);
  }
}
